'use client'

import { Composite, CompositeItem } from '@floating-ui/react'
import { cn } from 'design-system'
import { Check } from 'lucide-react'
import { FC } from 'react'

import { CompositeHTMLProps, FILTER_ITEM_CLASS_NAME } from './constants'
import { BooleanFilterConfig } from './types'

type BooleanSubFilterProps = {
  config: BooleanFilterConfig
  value: boolean | undefined
  onChange: (value: boolean | undefined) => void
}

export const BooleanSubFilter: FC<BooleanSubFilterProps> = ({
  config,
  value,
  onChange
}) => {
  const trueLabel = config.trueLabel ?? 'Yes'
  const falseLabel = config.falseLabel ?? 'No'

  const options = [
    { label: trueLabel, boolValue: true },
    { label: falseLabel, boolValue: false }
  ]

  const handleSelect = (boolValue: boolean) => {
    onChange(value === boolValue ? undefined : boolValue)
  }

  return (
    <Composite
      orientation="vertical"
      className="flex flex-col gap-1 p-2"
      role="listbox"
      aria-label={config.label}>
      {options.map(option => {
        const selected = value === option.boolValue
        return (
          <CompositeItem
            key={option.label}
            render={(htmlProps: CompositeHTMLProps) => (
              <button
                {...htmlProps}
                className={cn(FILTER_ITEM_CLASS_NAME, {
                  'bg-blue-100': htmlProps['data-active'] !== undefined,
                  'bg-gray-100': selected
                })}
                role="option"
                aria-selected={selected}
                onClick={() => handleSelect(option.boolValue)}>
                <span className="grow text-left">{option.label}</span>
                {selected ? (
                  <Check size={18} aria-hidden className="shrink-0" />
                ) : null}
              </button>
            )}
          />
        )
      })}
    </Composite>
  )
}
